/**
 * ローディングアニメーション
 */
import {debounce} from "debounce"
import getSkewBoxMargin from "../../utils/GetSkewBoxMargin"
import jsCookie from 'js-cookie'

export default function() {
  /**
   * transform: skew を設定した要素に、隙間が埋められる横幅を設定する
   * @param {*} el
   * @param {*} skewBoxMargin
   * @param {*} calcPercentage
   */
  const setSkewSizeWidth = (el, skewBoxMargin, calcPercentage) => {
    el.style.width = `calc(${calcPercentage}% + ${skewBoxMargin}px)`;
  }


  /**
   * transform: skew を設定した要素のリサイズ
   * @param {*} el
   */
  const resizeSkewBox = (el) => {
    let skewBoxMargin;

    const fn = (el) => {
      skewBoxMargin = getSkewBoxMargin(el, 65) * 2;
      setSkewSizeWidth(el, skewBoxMargin, 100);
    }

    // init
    fn(el);

    // resize event
    window.addEventListener('resize', debounce( () => {
      fn(el);
    }, 50));
  }

  const logoFadeOut = (startTime, resolve) => {
    const nowTime = new Date().getTime();
    const elapsedTime = nowTime - startTime;

    if(elapsedTime < 3000) { // 読み込みから3秒経過していない場合、1.5秒待機
      setTimeout(() => {
        elementIcon.classList.add('is-loaded')
        return resolve()
      }, 1000);
    } else {
      elementIcon.classList.add('is-loaded')
      return resolve()
    }
  }



  /**
   * 非同期でアニメーション
   */
  const element = document.querySelector('.c-loader')
  const elementIcon = document.querySelector('.c-loader-icon')

  let promise = new Promise((resolve, reject) => { // 読み込みが完了したら、skew要素のリサイズを適用
    const startTime = new Date().getTime();
    if(element) { // elementが存在する場合のみ。
      const fire = () => {
        resolve(startTime);
        resizeSkewBox(element);

        window.removeEventListener('load', fire, false);
      };
      window.addEventListener('load', fire, false);
    } else {
      resolve(startTime);
    }
  })


  // const getCookie = jsCookie.get('opened_frontPage')
  // console.log('getCookie', getCookie)
  // if(!getCookie) {
  //   jsCookie.set('opened_frontPage', 1)
  return promise
    .then((startTime) => { // #2 ローディングのロゴをフェードアウト
      return new Promise((resolve, reject) => {
        logoFadeOut(startTime, resolve);
      });
    })
    .then(() => { // #3 ローディング要素に、読み込み完了のclassを付与
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          element.classList.add('is-loaded');
          return resolve();
        }, 1500);
      })
    })
    .catch((err) => { // reject()が呼ばれた場合のエラーハンドリング
      return console.error(err);
    })
  // } else { // cookieが存在する場合は、アニメーションをスキップ
  //   return new Promise((resolve, reject) => {
  //     return resolve();
  //   })
  // }

}